import { render } from "./BeginWork.vue?vue&type=template&id=82647ad8&scoped=true"
import script from "./BeginWork.vue?vue&type=script&lang=js"
export * from "./BeginWork.vue?vue&type=script&lang=js"

import "./BeginWork.vue?vue&type=style&index=0&id=82647ad8&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82647ad8"]])

export default __exports__